module.exports = __webpack_public_path__ + "static/media/mars.dbadcd98.svg";